import styled from 'styled-components';


import colors from 'pubweb-react-components/dist/styles/colors';

import LandingPageStyles from './LandingPageStyles';

const SubpageContainer = styled.div`
    background-position: center top;
    color: ${colors.grayscaleCoolGray11};
    display: block;
    font-family: 'acumin-pro', sans-serif;
    
    width: 100%;

    .header-overlay {
        background-repeat: no-repeat;
        left: 0;
        position: absolute;
        top: 0;
        z-index: ${LandingPageStyles.zIndices.headerOverlay};
        width: 100%;
    }

    .header-overlay-filter {
        background-color: ${LandingPageStyles.grayFilter};
        height: 100%;
        width: 100%;
    }

    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        .header-overlay {
            background-image: url('${(props) => props.backgroundImages.desktopImage}');
            background-size: auto 100%;
            height: 265px;
        }

        display: table;

        .movin-header {
            margin-top: -2px;

            & > div, & > h3 {
                display: inline-block;
                vertical-align: middle;
            }

            h3 {
                padding-left: 4px;
            }
        }

         .body-container {
            border-top: 2px solid #d6d7d9;
            display: table;
            letter-spacing: -.35px;
            margin-top: 2px;
            padding-top: 15px;
            width: 86%;
        }
        
        .body-column-left {
            display: table-cell;
            width: 50%
        }

         .body-column-right {
            display: table-cell;
            padding-left: 25px;
            width: 50%
         }

    }

    
    @media screen and (min-width: 1501px) {
        .header-overlay {
            background-size: 100% auto;
        }
    }

    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        display: block;

        .header-overlay {
            background-image: url('${(props) => props.backgroundImages.tabletImage}');
            background-size: auto 100%;
            height: 265px;
        }

        .movin-header {
            display: table;
            margin-left: -10px;
            margin-top: -8px;

            & > div, & > h3 {
                display: table-cell;
                vertical-align: middle;
            }

            h3 {
                padding-left: 10px;
            }
        }

         .body-container {
            border-top: 2px solid #d6d7d9;
            display: block;
            letter-spacing: -.30px;
            margin-left: -3px;
            margin-top: 16px;
            padding-top: 24px;
            width: 99%;
        }
        
        .body-column-left {
            display: block;
            width: 100%;
        }

         .body-column-right {
            display: block;
            padding-left: 0;
            padding-top: 15px;
            width: 100%;
         }
    }

    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
        display: block;

        .header-overlay {
            background-image: url('${(props) => props.backgroundImages.mobileImage}');
            background-size: 100% auto;
            height: 270px;
        }

        .movin-header {
            display: table;
            margin-left: -10px;
            margin-top: -12px;

            & > div, & > h3 {
                display: table-cell;
                vertical-align: middle;
            }

            h3 {
                letter-spacing: -.1px;
                line-height: 1.4;
                padding-left: 12px;
                padding-right: 20px;
            }
        }

         .body-container {
            border-top: 2px solid #d6d7d9;
            display: block;
            letter-spacing: -.33px;
            line-height: 1.7;
            margin-left: -1px;
            margin-top: 7px;
            padding-right: 15px;
            padding-top: 20px;
            width: 100%;
        }
        
        .body-column-left {
            display: block;
            width: 100%;
        }

        .body-column-right {
            display: block;
            padding-left: 0px;
            padding-top: 15px;
            width: 100%;
         }
    }

    @media screen and (max-width: 392px) {
        .header-overlay {
            background-size: auto 100%;
        }
    }
`;

export default SubpageContainer;


// WEBPACK FOOTER //
// ./src/styles/SubpageStyles.js